import type { Scene } from '@babylonjs/core';
import {
  Color3,
  LinesMesh,
  VertexData,
  StandardMaterial,
} from '@babylonjs/core';

import type { BoundingBox } from '../loading-v2/OctreeGeometry';

/**
 * Box3Helper - Babylon.js implementation of a box helper
 * Displays a wireframe box to visualize a bounding box
 */
export class Box3Helper extends LinesMesh {
  constructor(
    name: string,
    box: BoundingBox,
    color: Color3 = new Color3(1, 1, 0),
    scene?: Scene,
  ) {
    super(name, scene);

    // Create vertices for the 8 corners of the box
    // prettier-ignore
    const positions = [
			box.min.x, box.min.y, box.min.z, // 0
			box.max.x, box.min.y, box.min.z, // 1
			box.max.x, box.min.y, box.max.z, // 2
			box.min.x, box.min.y, box.max.z, // 3
			box.min.x, box.max.y, box.min.z, // 4
			box.max.x, box.max.y, box.min.z, // 5
			box.max.x, box.max.y, box.max.z, // 6
			box.min.x, box.max.y, box.max.z  // 7
		];

    // Create indices for the 12 lines of the box
    // prettier-ignore
    const indices = [
			0, 1, 1, 2, 2, 3, 3, 0, // bottom face
			4, 5, 5, 6, 6, 7, 7, 4, // top face
			0, 4, 1, 5, 2, 6, 3, 7  // connecting edges
		];

    // Create the vertex data
    const vertexData = new VertexData();
    vertexData.positions = positions;
    vertexData.indices = indices;

    // Apply the vertex data to the mesh
    vertexData.applyToMesh(this);

    // Create and apply material
    const material = new StandardMaterial('box3HelperMaterial', scene);
    material.emissiveColor = color;
    material.disableLighting = true;
    material.wireframe = true;
    this.material = material;
  }
}
